export default "/app/global-wrapper-client/static/13e0960da2169b1796b781c873223995.woff";